module.exports = __webpack_public_path__ + "static/media/fz_verifydialogrobot_pt_PT.c6fb765d.png";